import { axiosInstance } from './index';
import {
    CandidateDataPunchedMetricsStatusResponseType,
    CandidateDataPunchedStatusResponseType,
    ExcelApiResponseData,
    FetchDataPunchDetailsRequestType,
    FetchDataPunchDetailsResponseType,
    FetchDataPunchStatusRequestType,
    FetchDataPunchStatusResponseType,
    FetchDataPunchUploadRequestType,
} from '../../types/excelUpload';

export const excelUploadDataService = {
    async setCandidateExcelUploadData(params: FormData) {
        const { data } = await axiosInstance.post(`Invitation/ExcelUploadByCompanies`, params);
        return data as ExcelApiResponseData;
    },

    async setCandidateOfferPunchExcelUploadData(params: FormData) {
        const { data } = await axiosInstance.post(`DataPunch/AddDataPunchDetailsViaExcel`, params);
        return data as ExcelApiResponseData;
    },

    async fetchDataPunchStatus(params: FetchDataPunchStatusRequestType) {
        const { data } = await axiosInstance.get(`DataPunch/FetchDataPunchStatus`, { params });
        return data as FetchDataPunchStatusResponseType;
    },

    async fetchDataPunchDetails(params: FetchDataPunchDetailsRequestType) {
        const { data } = await axiosInstance.get(`DataPunch/FetchDataPunchDetails`, { params });
        return data as FetchDataPunchDetailsResponseType;
    },

    async getDataPunchUploadDetails(params: FetchDataPunchUploadRequestType) {
        const { data } = await axiosInstance.get(`DataPunch/GetDataPunchUploadDetails`, { params });
        return data as CandidateDataPunchedStatusResponseType;
    },

    async getDataPunchMetricsStatus(params: FetchDataPunchStatusRequestType) {
        const { data } = await axiosInstance.get(`DataPunch/FetchDataPunchMetricsStatus`, { params });
        return data as CandidateDataPunchedMetricsStatusResponseType;
    },
};
